import React, { useEffect, useMemo, useState } from 'react';
import Classes from './Invoices.module.css';
import RecordTable from './RecordTable/RecordTable';
import backend from '../../../../../../../../api';
import { useSelector } from 'react-redux';

function fmtMoney(n, ccy = 'USD') {
  const x = Number(n || 0);
  return x.toLocaleString(undefined, { style: 'currency', currency: ccy });
}
function fmtDate(d) {
  if (!d) return '—';
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return '—';
  return dt.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
}

// Map DB → UI badges (keep simple for now)
function mapStatus(db) {
  if (db === 'completed' || db === 'paid') return 'Paid';
  if (db === 'overdue') return 'Overdue';
  return 'Pending';
}

export default function Invoices({ bookingId }) {
  const { token } = useSelector(s => s?.auth || {});
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  const load = async () => {
    if (!bookingId) return;
    setLoading(true);
    try {
      const { data } = await backend.get(`/api/invoices/by-booking?bookingId=${bookingId}`, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      setItems(Array.isArray(data?.items) ? data.items : []);
    } catch (e) {
      console.error('load invoices error', e);
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [bookingId]);

  // shape into table rows the component expects
  const rows = useMemo(() => {
    return items.map(inv => ({
      _id: inv._id,
      Number: inv.invoiceNumber || '—',
      Status: mapStatus(inv.status),
      Total: fmtMoney(inv.total, inv.currency || 'USD'),
      Created: fmtDate(inv.issuedAt),
      Paid: inv.paidAt ? fmtDate(inv.paidAt) : '—',
      raw: inv,
    }));
  }, [items]);

  return (
    <div className={Classes.hero}>
      <RecordTable
        bookingId={bookingId}
        rows={rows}
        loading={loading}
        onReload={load}
      />
    </div>
  );
}
